import React, { useState, useEffect, useContext }  from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import LayoutNavSectionCombinationList from 'components/layout_and_quote_builder/LayoutNavSectionCombinationList.jsx';
import SelectedList from 'components/layout_and_quote_builder/quote_builder/SelectedList.jsx';
import LayoutContext from 'components/contexts/LayoutContext.jsx';
import ChooseLayoutDimensions from 'components/layout_and_quote_builder/options/ChooseLayoutDimensions.jsx';
import GeneralNavSection from 'components/layout_and_quote_builder/quote_builder/GeneralNavSection.jsx';
import { shouldShowSectionLabel } from 'components/layout_and_quote_builder/utils/navSectionUtils.js';

const LayoutAndQuoteBuilderNavSection = ( props ) => {
  const myLayoutContext = useContext(LayoutContext);

  const defaultMaterialValues = () => {
    return {
      // Intentionally defaulting to layout dimension ID 21 instead of context value
      layout_dimension_id:  21,
      layout_dimension_unit: myLayoutContext.layoutOptions.layout_dimension_unit,
      layout_dimension_top_margin_diecutting: myLayoutContext.layoutOptions.layout_dimension_top_margin,
      layout_dimension_side_margin_diecutting: myLayoutContext.layoutOptions.layout_dimension_side_margin,
      layout_dimension_bottom_margin_diecutting: myLayoutContext.layoutOptions.layout_dimension_bottom_margin,

      layout_dimension_top_margin_printing: myLayoutContext.layoutOptions.layout_dimension_top_margin,
      layout_dimension_side_margin_printing: myLayoutContext.layoutOptions.layout_dimension_side_margin,
      layout_dimension_bottom_margin_printing: myLayoutContext.layoutOptions.layout_dimension_bottom_margin,
    }
  }

  // Use props if provided, otherwise use local state (for backwards compatibility)
  const selectedList = props.selectedList !== undefined ? props.selectedList : [];
  const setSelectedList = props.setSelectedList || (() => {});
  const previousSelectedList = props.previousSelectedList;

  const [materialLayoutDimensions, setMaterialLayoutDimensions] = useState( defaultMaterialValues() )

  const navSectionLabel = () => {
    if(props.navSection.label) {
      return <span className={styles.navSectionLabel}> {props.navSection.label} </span>
    }
  }

  const chooseLayoutDimensionsComponent = () => {
    return <ChooseLayoutDimensions
      title={t('layouts.material_sheet_dimensions')}
      hideMargins={false}
      disableMargins={selectedList.length != 0}
      hideCustom={true}
      defaultValues={materialLayoutDimensions}
      publicSetter={setMaterialLayoutDimensions}
      index={props.index}
    />
  }

  useEffect( () => {
    // console.log( { materialLayoutDimensions } )
  }, [materialLayoutDimensions])

  useEffect( () => {
    // console.log( { props } )
  }, [props])


  if(props.navSection.part_type == "general") {
    return <GeneralNavSection totalNavSectionSize={props.totalNavSectionSize} />
  }

  return (
    <>
    <div className={styles.LayoutAndQuoteBuilderNavSection}>

      <div className={styles.nav_section}>

        {shouldShowSectionLabel(props.totalNavSectionSize, props.navSection.label) && (
          <center> <h2> { props.navSection.label} </h2> </center>
        )}

        <div className={styles.nav_section_layout_selector}> <span> {chooseLayoutDimensionsComponent()} </span> </div>

          { selectedList.length == 0 && <LayoutNavSectionCombinationList
            navSection={props.navSection}
            index={props.index}
            count={props.count}
            setSelectedList={setSelectedList}
            materialLayoutDimensions={materialLayoutDimensions}
            previousSelectedList={previousSelectedList}
          /> }

        <SelectedList selectedList={selectedList} setSelectedList={setSelectedList} config={props.config} index={props.index} totalNavSectionSize={props.totalNavSectionSize}/>

      </div>
    </div>
    <br />
    <br />
    </>
  )
}

export default LayoutAndQuoteBuilderNavSection;
